import { useMemo } from "react";
import { bindActionCreators } from "@reduxjs/toolkit";
import {
  type RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../store/store";
import accountProfileThunk from "../redux/thunk";
import { accountSettingsActions } from "../redux/slice";

export const useProfile = () => {
  const {
    user_profile,
    reset_password,
    error,
    balance,
    pets,
    pet
  } = useAppSelector((state: RootState) => state.accountSettings);

  const dispatch = useAppDispatch();
  return useMemo(() => {
    const actions = {
      ...accountSettingsActions,
      ...accountProfileThunk,
    };
    return {
      ...bindActionCreators(actions, dispatch),
      userProfile: user_profile,
      reset_password,
      pets,
      pet,
      error,
      balance,
    };
  }, [
    dispatch,
    user_profile,
    reset_password,
    error,
    balance,
    pets,
    pet
  ]);
};

export default useProfile;
